<h1 mat-dialog-title>{{ title }}</h1>
<hr />

<form id="form-staff" autocomplete="off" [formGroup]="form" (ngSubmit)="enviar()">
    <mat-dialog-content>
        <!-- Foto de perfil arriba del formulario -->
<div class="foto-container text-center my-3">
  <div class="foto-wrapper">
    <img
      [src]="fotoPreview || './assets/img/default-profile.png'"
      alt="Foto de perfil"
      class="foto-perfil"
    />
    <label for="fotoInput" class="foto-upload-btn">
      <mat-icon>add</mat-icon>
    </label>
    <input
      type="file"
      id="fotoInput"
      accept="image/*"
      (change)="onFotoSeleccionada($event)"
      hidden
    />
  </div>
  <small class="text-muted d-block mt-2">Selecciona una imagen</small>
</div>

        <mat-tab-group animationDuration="1000ms">
            <!-- Datos Personales -->
            <mat-tab label="Datos Personales">
                <div class="container-fluid mt-4">
                    <div class="row">
                        <div class="col-12 col-sm-6 col-md-4 form-group">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Nombre</mat-label>
                                <input matInput formControlName="nombre" maxlength="50" uppercase lettersOnly />
                                <mat-error *ngIf="isValidField('nombre')">{{ getFieldError('nombre') }}</mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-12 col-sm-6 col-md-4 form-group">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Apellido Paterno</mat-label>
                                <input matInput formControlName="apellidoPaterno" maxlength="50" uppercase
                                    lettersOnly />
                                <mat-error *ngIf="isValidField('apellidoPaterno')">{{ getFieldError('apellidoPaterno')
                                    }}</mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-12 col-sm-6 col-md-4 form-group">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Apellido Materno</mat-label>
                                <input matInput formControlName="apellidoMaterno" maxlength="50" uppercase
                                    lettersOnly />
                                <mat-error *ngIf="isValidField('apellidoMaterno')">{{ getFieldError('apellidoMaterno')
                                    }}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-sm-6 col-md-4 form-group">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Fecha de Nacimiento</mat-label>
                                <input matInput type="date" formControlName="fechaNacimiento" />
                                <mat-error *ngIf="isValidField('fechaNacimiento')">{{ getFieldError('fechaNacimiento')
                                    }}</mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-12 col-sm-6 col-md-2 form-group">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Edad</mat-label>
                                <input matInput type="number" formControlName="edad" maxlength="2" numbersOnly />
                                <mat-error *ngIf="isValidField('edad')">{{ getFieldError('edad') }}</mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-12 col-sm-6 col-md-3 form-group">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Sexo</mat-label>
                                <mat-select formControlName="sexo">
                                    <mat-option *ngFor="let sexo of sexoList" [value]="sexo.value">{{ sexo.viewValue
                                        }}</mat-option>
                                </mat-select>
                                <mat-error *ngIf="isValidField('sexo')">{{ getFieldError('sexo') }}</mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-12 col-sm-6 col-md-3 form-group">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>CURP</mat-label>
                                <input matInput formControlName="curp" minlength="18" maxlength="18" uppercase
                                    alphanumericOnly />
                                <mat-error *ngIf="isValidField('curp')">{{ getFieldError('curp') }}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
               </div>
            </mat-tab>

            <!-- Domicilio -->
            <mat-tab label="Domicilio">
                <div class="container-fluid mt-4">
                    <div class="row">
                        <div class="col-12 col-sm-3 col-md-4 form-group">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Calle</mat-label>
                                <input matInput formControlName="calle" maxlength="90" uppercase alphanumericOnly />
                            </mat-form-field>
                        </div>

                        <div class="col-12 col-sm-3 col-md-2 form-group">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Número int.</mat-label>
                                <input matInput formControlName="numeroInterior" maxlength="9" uppercase
                                    alphanumericOnly />
                            </mat-form-field>
                        </div>

                        <div class="col-12 col-sm-3 col-md-2 form-group">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Número ext.</mat-label>
                                <input matInput formControlName="numeroExterior" maxlength="9" uppercase
                                    alphanumericOnly />
                            </mat-form-field>
                        </div>

                        <div class="col-12 col-sm-3 col-md-4 form-group">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Código Postal</mat-label>
                                <input matInput formControlName="cp" maxlength="5" numbersOnly />
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-sm-6 col-md-6 form-group">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Ciudad</mat-label>
                                <input matInput formControlName="ciudad" maxlength="25" uppercase alphanumericOnly />
                            </mat-form-field>
                        </div>

                        <div class="col-12 col-sm-6 col-md-6 form-group">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Municipio</mat-label>
                                <input matInput formControlName="municipio" maxlength="50" uppercase alphanumericOnly />
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-raised-button color="primary" class="m-1" type="submit" *ngIf="mostrarBoton">
            <mat-icon>save</mat-icon> Guardar
        </button>
        <button mat-raised-button color="warn" class="m-1" mat-dialog-close>
            <mat-icon>close</mat-icon> Cancelar
        </button>
    </mat-dialog-actions>
</form>